import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/handlers";
import api from "../../../config/axios";
import { logout } from "../auth";

const initialState = {
  summary: {}
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, () => initialState)
      .addCase(fetchDashboardSummary.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardSummary.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.summary = action.payload;
        state.error = null;
      })
      .addCase(fetchDashboardSummary.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      })
  },
});

export const fetchDashboardSummary = createAsyncThunk(
  "dashboard/summary",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/dashboard");
      const result = response.data.payload;
      return result;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export default slice.reducer;
